<script>
  // @ts-nocheck

  import { goto } from '$app/navigation';
  import { AlertModal, ModalProtected } from '$lib/components';
  import { Routes } from '$lib/constants/routes';
  import { EventName, trackEvent } from '$lib/services/analytics';
  import { deleteApp } from '$lib/services/app';
  import { onMount } from 'svelte';

  export let form;
  export let data;

  let isDeleteAlertOpen = false;

  const { app } = data;

  function handleEditApp() {
    goto(`${Routes.ROOT}${app?.id}/edit`);
  }

  async function handleDeleteApp() {
    try {
      await deleteApp(app.id);

      trackEvent(EventName.APP_DELETE, {
        app: data.appId,
        email: data.email,
      });

      goto(Routes.MY_APPS);
    } catch (e) {
      console.error(e);
    } finally {
      handleToggleDeleteModal();
    }
  }

  function handleToggleDeleteModal() {
    isDeleteAlertOpen = !isDeleteAlertOpen;
  }

  onMount(() => {
    trackEvent(EventName.APP_VISIT, {
      app: app.id,
      email: data.email,
    });
  });
</script>

{#if form?.success}
  <div class="fixed top-0 right-0 z-20 p-5 px-7">
    <p class="bg-white py-1 px-5 rounded">
      <small> Link for editing is sent to owner's email! </small>
    </p>
  </div>
{:else if form?.error}
  <div class="fixed top-0 right-0 z-20 p-5 px-7">
    <p class="bg-white py-1 px-5 rounded">
      <small>
        {form.error}
      </small>
    </p>
  </div>
{/if}

{#if data.isAllowedEditing}
  {#if isDeleteAlertOpen}
    <AlertModal
      title="Delete App"
      description="Are you sure you want to delete the app?"
      onClickSubmit={handleDeleteApp}
      submitLabel="Yes"
      onClickCancel={handleToggleDeleteModal}
      cancelLabel="No"
    />
  {/if}
  <div class="fixed bottom-0 right-0 z-20 m-5 hover:opacity-100">
    <button
      type="button"
      class="bg-white w-10 h-10 mx-1 shadow-sm rounded-full hover:bg-gray-100"
      on:click={handleToggleDeleteModal}
    >
      ❌
    </button>
    <button
      type="button"
      class="bg-white w-10 h-10 shadow-sm rounded-full hover:bg-gray-100"
      on:click={handleEditApp}
    >
      🖊️
    </button>
  </div>
{/if}

<ModalProtected form={form} />
